import { TypedParam } from "./_Base";
import { FloatParam } from "./Float";
import { ParamEvent } from "../poly/ParamEvent";
import { CoreType } from "../../core/Type";
export class TypedMultipleParam extends TypedParam {
  constructor() {
    super(...arguments);
    this._components_contructor = FloatParam;
  }
  get components() {
    return this._components;
  }
  isNumeric() {
    return true;
  }
  isDefault() {
    for (let c of this.components) {
      if (!c.isDefault()) {
        return false;
      }
    }
    return true;
  }
  rawInput() {
    return this._components.map((c) => c.rawInput());
  }
  rawInputSerialized() {
    return this._components.map((c) => c.rawInputSerialized());
  }
  _copyValue(param) {
    for (let i = 0; i < this.components.length; i++) {
      const component = this.components[i];
      const src_component = param.components[i];
      component.copyValue(src_component);
    }
  }
  initComponents() {
    if (this._components != null) {
      return;
    }
    let index = 0;
    this._components = new Array(this.componentNames().length);
    for (let component_name of this.componentNames()) {
      const component = new this._components_contructor(this.scene(), this.node);
      let default_val;
      if (CoreType.isArray(this._default_value)) {
        default_val = this._default_value[index];
      } else {
        default_val = this._default_value[component_name];
      }
      component.options.copy(this.options);
      component.setInitValue(default_val);
      component.setName(`${this.name()}${component_name}`);
      component.set_parent_param(this);
      this._components[index] = component;
      index++;
    }
  }
  async processComputation() {
    await this.compute_components();
    this.set_value_from_components();
  }
  set_value_from_components() {
  }
  hasExpression() {
    var _a;
    for (let c of this.components) {
      if ((_a = c.expressionController) == null ? void 0 : _a.active()) {
        return true;
      }
    }
    return false;
  }
  async compute_components() {
    const components = this.components;
    const promises = [];
    for (let c of components) {
      if (c.isDirty()) {
        promises.push(c.compute());
      }
    }
    await Promise.all(promises);
    this.removeDirtyState();
  }
  _prefilterInvalidRawInput(raw_input) {
    if (!CoreType.isArray(raw_input)) {
      const number_or_string = raw_input;
      const raw_input_wrapped_in_array = this.componentNames().map(() => number_or_string);
      return raw_input_wrapped_in_array;
    } else {
      return raw_input;
    }
  }
  processRawInput() {
    const cooker = this.scene().cooker;
    cooker.block();
    const components = this.components;
    for (let c of components) {
      c.emitController.blockParentEmit();
    }
    const value = this._raw_input;
    let prev_value = 0;
    if (CoreType.isArray(value)) {
      for (let i = 0; i < components.length; i++) {
        let component_value = value[i];
        if (component_value == null) {
          component_value = prev_value;
        }
        components[i].set(component_value);
        prev_value = component_value;
      }
    } else {
      for (let i = 0; i < components.length; i++) {
        const component_name = this.componentNames()[i];
        let component_value = value[component_name];
        if (component_value == null) {
          component_value = prev_value;
        }
        components[i].set(component_value);
        prev_value = component_value;
      }
    }
    cooker.unblock();
    for (let i = 0; i < components.length; i++) {
      components[i].emitController.unblockParentEmit();
    }
    this.emitController.emit(ParamEvent.VALUE_UPDATED);
  }
}
